// extracted by mini-css-extract-plugin
export var settingsList = "_34-0";
export var settingsRow = "_34-1";
export var warningDot = "_34-2";